export interface CallbackInfo {
    state: string;
    origin: string;
}

export type NewlyCreatedKey = {
    apiKey: string;
    name: string;
};

export const MESSAGE_TYPE = 'FLOW_API_KEY_RESPONSE';
